import { render, staticRenderFns } from "./Coberturas.vue?vue&type=template&id=c5ed3b40&scoped=true"
import script from "./Coberturas.vue?vue&type=script&lang=js"
export * from "./Coberturas.vue?vue&type=script&lang=js"
import style0 from "./Coberturas.vue?vue&type=style&index=0&id=c5ed3b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ed3b40",
  null
  
)

export default component.exports